import {IElement} from '../../incase-domain/elements';
import {ELEMENT} from '../../incase-domain/elements/base/ElementTypes';
import useElementActions from '../../utils/hooks/slideUpdates/useElementActions';

export const useEmptyModalElementCleanup = (): ((element: IElement, index: number) => void) => {
    const {deleteElement} = useElementActions();

    return (element: IElement, index: number): void => {
        if (!element) return;
        if (element.type !== ELEMENT.MODAL) return;
        if (element.elementToClickForDisplay && element.elementToClickForDisplay.length > 0) return;
        deleteElement(index);
    };
};
